var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhostIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m21.43 9.08c-.22-5.07-4.36-9.03-9.43-9.03s-9.21 3.96-9.43 9.03l-.56 13.04c-.02.53.2 1.04.6 1.38.41.35.94.49 1.46.39l2.86-.58c.44-.08.88-.08 1.31.02l2.75.61c.33.07.67.11 1.01.11s.68-.04 1.01-.11l2.75-.61c.43-.1.87-.1 1.31-.02l2.85.58c.53.1 1.06-.04 1.47-.39.4-.34.62-.85.6-1.38zm-12.93 4.97c-1.4 0-2.5-1.54-2.5-3.5s1.1-3.5 2.5-3.5 2.5 1.54 2.5 3.5-1.1 3.5-2.5 3.5zm7 0c-1.4 0-2.5-1.54-2.5-3.5s1.1-3.5 2.5-3.5 2.5 1.54 2.5 3.5-1.1 3.5-2.5 3.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostIcon);
export default __webpack_public_path__ + "static/media/ghost_icon.37b47ea1.svg";
export { ForwardRef as ReactComponent };